// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-business-modal-modal_card-XDpcG {
  width: 340px;
  height: auto;
  max-height: 600px;
}

.edit-business-modal-textField_container-Lex_U {
  width: 100%;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/edit-business-modal/edit-business-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  max-height: 600px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-business-modal-modal_card-XDpcG`,
	"textField_container": `edit-business-modal-textField_container-Lex_U`
};
export default ___CSS_LOADER_EXPORT___;
